// src/file-extensions.ts
var FILE_EXTENSIONS = Object.freeze({
  XLSX: "xlsx",
  ZIP: "zip",
  PDF: "pdf",
  CSV: "csv"
});

// src/mime-types.ts
var MIME_TYPES = Object.freeze({
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ZIP: "application/zip",
  PDF: "application/pdf",
  CSV: "text/csv"
});

// src/format-file-size.ts
var ONE_KILOBYTE = 1024;
var ONE_MEGABYTE = ONE_KILOBYTE * 1024;
function formatFileSize(bytes) {
  if (bytes < ONE_KILOBYTE) {
    return `${bytes} B`;
  }
  if (bytes < ONE_MEGABYTE) {
    return `${(bytes / ONE_KILOBYTE).toFixed(1)} KB`;
  }
  return `${(bytes / ONE_MEGABYTE).toFixed(1)} MB`;
}

// src/types/compression-types/compression-level.ts
var COMPRESSION_LEVEL = Object.freeze({
  LIGHT: "LIGHT",
  MEDIUM: "MEDIUM",
  MAXIMUM: "MAXIMUM"
});
var COMPRESSION_LEVEL_MAP = {
  [COMPRESSION_LEVEL.LIGHT]: 1,
  [COMPRESSION_LEVEL.MEDIUM]: 6,
  [COMPRESSION_LEVEL.MAXIMUM]: 9
};

// src/compression.ts
import { isArray } from "@vy/array";
import JSZip from "jszip";
async function compress(files, level = COMPRESSION_LEVEL.MEDIUM) {
  if (!isArray(files)) {
    return compress([files], level);
  }
  const zip = new JSZip();
  files.forEach(({ filename, buffer }) => {
    zip.file(filename, new Uint8Array(buffer));
  });
  return zip.generateAsync({
    type: "nodebuffer",
    compression: "DEFLATE",
    compressionOptions: { level: COMPRESSION_LEVEL_MAP[level] }
  });
}

// src/file-size.ts
var FileSize = Object.freeze(
  {
    ONE_KB: Math.pow(1024, 1),
    ONE_MB: Math.pow(1024, 2),
    ONE_GB: Math.pow(1024, 3)
  }
);
export {
  COMPRESSION_LEVEL,
  FILE_EXTENSIONS,
  FileSize,
  MIME_TYPES,
  compress,
  formatFileSize
};
